import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { IconEdit01 } from "@pentabd/icons";

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  handleScrollToTop: () => void,
  handleQueryById: (id: string | number) => void,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "name",
      name: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.COLUMN.NAME"),
      render: (_: string, row: any) => (
        <Text color="subtitle2">
          {language === "en" ? row.name : row.nameBn || row.nameEn}
        </Text>
      ),
    },
    {
      id: 2,
      key: "address",
      name: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.COLUMN.ADDRESS"),
      render: (_: string, row: any) => {
        return (
          <Text color="subtitle2">
            {" "}
            {language === "en" ? row.address : row.addressBn || row.addressBn}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "type",
      name: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.COLUMN.TYPE"),
      render: (type: any) => (
        <Text color="subtitle2">
          {language === "en" ? type.nameEn : type.nameBn || type.nameEn}
        </Text>
      ),
    },
    {
      id: 4,
      key: "district",
      name: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.COLUMN.DISTRICT"),
      render: (district: any) => (
        <Text color="subtitle2">
          {language === "en" ? district.nameEn : district.nameBn}
        </Text>
      ),
    },
    {
      id: 5,
      key: "division",
      name: t("HRM_SETTINGS.OFFICE_ADDRESS.TABLE.COLUMN.DIVISION"),
      render: (division: any) => (
        <Text color="subtitle2">
          {language === "en" ? division.nameEn : division.nameBn}
        </Text>
      ),
    },
    {
      id: 6,
      key: "id",
      name: "",
      render: (id: number | string) => {
        return (
          <div
            onClick={() => {
              handleScrollToTop();
              handleQueryById(id);
            }}
            className="cursor-pointer"
          >
            <IconEdit01 size={24} fill="subtitle1" />
          </div>
        );
      },
    },
  ];
};
